export default function Contact() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-6">
            有任何建议、合作意向或影片推荐，欢迎随时与我们联系
          </p>

          <div className="rounded-xl bg-background-50 p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
              <div className="text-center p-4">
                <div className="w-11 h-11 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="text-sm font-bold font-heading text-foreground-900 mb-1">
                  投稿与合作
                </h3>
                <p className="text-xs text-foreground-500 break-all">
                  contact@7788movie.com
                </p>
              </div>
              <div className="text-center p-4">
                <div className="w-11 h-11 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-3">
                  <i className="ri-wechat-line text-xl"></i>
                </div>
                <h3 className="text-sm font-bold font-heading text-foreground-900 mb-1">
                  微信公众平台
                </h3>
                <p className="text-xs text-foreground-500">
                  搜索关注「7788电影网」
                </p>
              </div>
              <div className="text-center p-4">
                <div className="w-11 h-11 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 mb-3">
                  <i className="ri-film-line text-xl"></i>
                </div>
                <h3 className="text-sm font-bold font-heading text-foreground-900 mb-1">
                  影片推荐
                </h3>
                <p className="text-xs text-foreground-500">
                  填写推荐表单即可
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}